import { useMapEvents } from 'react-leaflet';
import { useMapStore } from './store';

export function useViewport() {
  const setViewport = useMapStore((s) => s.setViewport);

  useMapEvents({
    moveend(e) {
      const map = e.target;
      const c = map.getCenter();
      setViewport([c.lat, c.lng], map.getZoom());
    },
  });
}
